import { useContext } from 'react';

import MetadataContext, { MetadataContextValues } from './context';

const useMetadataContext = (): MetadataContextValues => useContext(MetadataContext);

export default useMetadataContext;
